import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { InputContainer, InputField, SendButton } from "./chatbot.styled";

const ChatInput = ({ onSend, disabled }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState("");

  const handleSend = () => {
    if (disabled || !value.trim()) return;
    onSend(value);
    setValue("");
  };

  return (
    <InputContainer>
      <InputField
        type="text"
        placeholder={t('chatbot.input.placeholder')}
        aria-label={t('chatbot.aria.messageInput')}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && handleSend()}
        disabled={disabled}
      />
      <SendButton
        type="button"
        onClick={handleSend}
        disabled={disabled}
        aria-label={t('chatbot.aria.sendMessage')}
        title={t('chatbot.aria.sendMessage')}
      >
        ➤
      </SendButton>
    </InputContainer>
  );
};

export default ChatInput;
